import { GitErrorStatusCode } from './errors.enum';
import { GitPushError } from './git-push.git-error';

/**
 * Thrown when `git push` failed, due to an internal server error.
 */
export class GitPushServerError extends GitPushError {
  constructor() {
    super('Internal server error', false);
  }

  readonly gitErrorCode = GitErrorStatusCode.GitPushServer;
}
